<template>
	<el-main class="materialwrap">
		<div class="mybread">
			<p><i class="el-icon-location"></i>当前位置：</p>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-if="query.kind == 1">
				<el-breadcrumb-item>客户项目</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
				<el-breadcrumb-item
					:to="{ path: `/project/detail?id=${query.cid ? query.cid : query.pid}` }">项目详情</el-breadcrumb-item>
				<el-breadcrumb-item>{{ pathtype }}供应商发票</el-breadcrumb-item>
			</el-breadcrumb>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-else-if="query.kind == 2">
				<el-breadcrumb-item>行政采购项目</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/admin' }">项目列表</el-breadcrumb-item>
				<el-breadcrumb-item
					:to="{ path: `/admin/view?id=${query.cid ? query.cid : query.pid}&mType=2` }">项目详情</el-breadcrumb-item>
				<el-breadcrumb-item>{{ pathtype }}供应商发票</el-breadcrumb-item>
			</el-breadcrumb>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-else-if="query.kind == 3">
				<el-breadcrumb-item>人力资源项目</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/human' }">项目列表</el-breadcrumb-item>
				<el-breadcrumb-item
					:to="{ path: `/admin/view?id=${query.cid ? query.cid : query.pid}&mType=3` }">项目详情</el-breadcrumb-item>
				<el-breadcrumb-item>{{ pathtype }}供应商发票</el-breadcrumb-item>
			</el-breadcrumb>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-else>
				<el-breadcrumb-item>客户项目</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/pay' }">支付管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{ pathtype }}供应商发票</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 预算说明 -->
		<div class="base1">
			<h3 class="ntitle">预算说明</h3>
			<ul>
				<li>
					<p>
						<label>预算：</label><a>{{ form.budget }}</a>
					</p>
					<p>
						<label>服务说明：</label><a style="white-space: pre-wrap;">{{ form.service_info }}</a>
					</p>
					<p style="width: 150%;">
						<label>清单附件：</label>
						<template>
							<ul class="anlist">
								<li v-for="(item, index) in fileList" :key="index">
									<div class="abox">
										<!-- 选择文件 -->
										<el-col :span="4"
											v-if="NodeInclude('46') || NodeInclude('134') || NodeInclude('170')">
											<el-upload class="upload-demo" ref="upFile" action="#" :limit="1"
												:show-file-list="false" :auto-upload="false"
												accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png"
												:file-list="item.flist"
												:on-change="(arg) => uploadFile(arg, 'fileList', 'upFile', item, index)">
												<el-button size="small" style="width: 80px;">选择文件</el-button>
											</el-upload>
										</el-col>
										<!-- 文件预览及下载 -->
										<template v-if="item.origin_name">
											<el-col :span="20">
												<el-col :span="18">
													<div class="origin-name">{{ item.origin_name }}</div>
												</el-col>
												<el-col :span="2">
													<el-link type="primary" style="margin-right:5px"
														:href="item.httpFile" target="_blank">查看</el-link>
												</el-col>
											</el-col>
										</template>
									</div>
									<el-button class="bbtn"
										v-if="(index === 0) && (NodeInclude('46') || NodeInclude('134') || NodeInclude('170'))"
										icon="el-icon-plus" @click="addImage(fileList)" circle></el-button>
									<el-button class="bbtn"
										v-if="index > 0 && (NodeInclude('46') || NodeInclude('134') || NodeInclude('170'))"
										icon="el-icon-minus" @click="removeImage(fileList, index)" circle></el-button>
								</li>
							</ul>
						</template>
					</p>
				</li>
				<li>
					<p>
						<label>选择支付类别：</label><a>{{ dd.pay_type[form.pay_type] }}</a>
					</p>
					<p>
						<label>服务类目：</label><a>{{ query.kind == 2 || query.kind == 3 ? form.service_type_name :
							form.service_type_name }}</a>
					</p>
				</li>
			</ul>
		</div>
		<!-- 发票信息 -->
		<div class="form myform" v-if="NodeInclude('95') || NodeInclude('146') || NodeInclude('176')">
			<el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
				<div class="formtitle">发票信息</div>
				<template>
					<ul class="anlist">
						<li v-for="(item, index) in form.invoiceList" :key="index">
							<div class="abox">
								<el-form-item label="发票代码：" prop="invoice_code">
									<el-col :span="12">
										<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_code"
											clearable :disabled="(item.id && item.id != 0) && level != 1" />
									</el-col>
								</el-form-item>
								<el-form-item label="发票号码：" prop="invoice_no">
									<el-col :span="12">
										<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_no" clearable
											:disabled="(item.id && item.id != 0) && level != 1" />
									</el-col>
								</el-form-item>
								<el-form-item label="金额：" prop="invoice_amount">
									<el-col :span="12">
										<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_amount"
											@change="v => numberFn(v, item)" clearable
											:disabled="(item.id && item.id != 0) && level != 1" />
									</el-col>
								</el-form-item>
								<el-form-item label="发票日期：" prop="invoice_date">
									<el-col :span="5">
										<el-date-picker v-model="item.invoice_date" type="datetime"
											value-format="yyyy-MM-dd"
											:disabled="(item.id && item.id != 0) && level != 1" style="width: 100%;">
										</el-date-picker>
									</el-col>
								</el-form-item>
								<template>
									<ul class="anlist">
										<li v-for="(_it, _id) in item.atta_str" :key="_id">
											<div class="abox">
												<el-form-item :label='`发票附件${_id + 1}：`'>
													<!-- 选择文件 -->
													<el-col :span="3" v-if="(!_it.id && !_it.file_id)">
														<el-upload class="upload-demo" :ref="`$upFile${_id}`" action="#"
															:limit="1" :show-file-list="false" :auto-upload="false"
															accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png"
															:file-list="_it.flist"
															:on-change="(arg) => uploadFile2(arg, item.atta_str, `$upFile${_id}`, _it, _id)">
															<el-button size="small" style="width: 100%">选择文件</el-button>
														</el-upload>
													</el-col>
													<!-- 文件预览及下载 -->
													<template v-if="_it.origin_name">
														<el-col :span="10">
															<el-col :span="18">
																<div class="origin-name">
																	{{ _it.origin_name }}</div>
															</el-col>
															<el-col :span="4">
																<el-link type="primary" style="margin-right:5px"
																	:href="_it.httpFile" target="_blank">查看</el-link>
															</el-col>
														</el-col>
													</template>
												</el-form-item>
											</div>
											<el-button class="bbtn" v-if="(!_it.id && !_it.file_id)"
												icon="el-icon-minus" @click="removeImage2(item.atta_str, _id)"
												circle></el-button>
										</li>
										<el-button type="primary" style="margin: 0 0 15px 150px;" class="addbtn"
											@click="addImage2(item.atta_str)">新增发票附件</el-button>
									</ul>
								</template>
								<el-form-item label="发票状态：" prop="status">
									<el-col :span="12">
										<span>{{ dd.invoice_update[item.status] }}</span>
									</el-col>
								</el-form-item>
							</div>
							<el-button class="abtn" icon="el-icon-minus" @click="removeInvoice(form.invoiceList, index)"
								circle></el-button>
						</li>
						<el-button type="primary" style="margin: 0 0 15px -5px;" class="addbtn"
							@click="addInvoice(form.invoiceList)">新增发票</el-button>
					</ul>
				</template>
				<el-form-item label="">
					<el-col>
						<el-button @click="resetForm('form')">取消</el-button>
						<el-button type="primary" @click="submitForm('form')">保存</el-button>
					</el-col>
				</el-form-item>

			</el-form>
		</div>
	</el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
import { timeFormat } from '@/utils/index.js'
export default {
	name: 'paydetail',
	data() {
		return {
			nodeLimtList: [],
			mType: '',
			level: '',
			pay_type: '',
			remindShow: false,
			nowCost: '0.00',
			projectList: [],//项目列表
			projectArr: {

			},//项目详情
			billList: [],//收款计划
			sonList: [],//子项目
			purchaseList: [],//供应商合同列表
			vendorList: [],//供应商列表
			form: {
				pay_id: '',
				project_id: '',
				son_project_id: '',
				contract_name: '',
				contract_no: '',
				pay_info: '',
				vendor_id: '',
				vendor_type: '',
				budget: '',
				pay_type: '1',
				service_type: '',
				service_info: '',
				contract_id: '',
				check_info: '',
				atta_str: '',
				invoiceList: [
					{ invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '', atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }], }
				],
				invoice_str: '',
				invoice_del: '',
				invoice_atta_del: '',
				projectArr: {//项目详情
					contract_name: '',
				},
				projectSonArr: {//子项目详情
					contract_name: '',
				},
			},
			del_invoice_list: [],
			del_invoice_atta_list: [],
			rules: {

			},
			fileList: [
				{ origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
			],
			fileList1: [
				{ origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
			],
			del_atta_list: [],
			del_atta_list1: [],
		}
	},
	created() {
		// console.log(this.$route)
		this.query = this.$route.query
		this.mType = this.query.mType ? this.query.mType : '1'
		this.query.id && this.getDetail(this.query.id)
	},
	mounted() {

	},
	watch: {

	},
	methods: {
		checkUrlFn() {
			// 获取当前URL的哈希部分  
			const hash = window.location.hash;
			// 移除'#'字符  
			const url = hash.substring(1);
			
			let postData = {
				url_path: url
			}
			api.checkLoginUrl(postData).then((res) => {
				if (res.status == 400) {
					this.$message({
						type: 'info',
						message: '暂无权限',
					})
					this.$router.push({
						path: `/home`
					});
				}
			})
		},
		checkNodeFn(menu_id) {
			let postData = {
				menu_id,
			}
			api.checkNode(postData).then((res) => {
				this.nodeLimtList = res.node_ids.split(',')
			})
		},
		NodeInclude(val) {
			return this.nodeLimtList.includes(val)
		},
		numberFn(v, item) {
			v = v.toString().replace(/,/g, "")
			item.invoice_amount = v
		},
		//选择文件
		uploadFile(file, fileList, ref, item, index) {
			let formData = new FormData();
			formData.append("file_arr", file.raw);
			formData.append("type", 2);
			api.uploadFile(formData)
				.then((res) => {
					this[fileList][index] = {
						...item,
						origin_name: res.origin_name,
						file_name: res.file_name,
						httpFile: res.httpFile,
					}
					this.$forceUpdate()
					this.$refs[ref][index].clearFiles();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		addImage(arr) {
			arr.push({
				origin_name: '', file_name: '', httpFile: '', id: '', flist: []
			});
		},
		removeImage(arr, index) {
			if (arr[index].id) {
				this.del_atta_list.push(arr[index].id);
			}
			console.log(this.del_atta_list);
			arr = arr.splice(index, 1);
		},
		//选择文件
		uploadFile2(file, fileList, ref, item, index) {
			console.log(file, fileList, ref, item, index);
			let formData = new FormData();
			formData.append("file_arr", file.raw);
			formData.append("type", 2);
			api.uploadFile(formData)
				.then((res) => {
					fileList[index] = {
						...item,
						origin_name: res.origin_name,
						file_name: res.file_name,
						httpFile: res.httpFile,
					}
					this.$forceUpdate()
					this.$refs[ref][0].clearFiles();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		addImage2(arr) {
			console.log(arr);
			arr.push({ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] });
			this.$forceUpdate()
		},
		removeImage2(arr, index) {
			if (arr[index].id) {
				this.del_invoice_atta_list.push(arr[index].id);
			}
			console.log(this.del_invoice_atta_list);
			arr = arr.splice(index, 1);
			this.$forceUpdate()
		},
		addInvoice(arr) {
			arr.push({
				invoice_no: '',
				invoice_code: '',
				invoice_amount: '',
				invoice_date: '',
				atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }],
			});
		},
		removeInvoice(arr, index) {
			this.del_invoice_list.push(arr[index].id);
			console.log(this.del_invoice_list);
			arr = arr.splice(index, 1);
		},
		async getDetail(id) {
			this.checkUrlFn()
			this.checkNodeFn('61')
			this.$fly
				.post('apiProject_getPayDetail.html', {
					pay_id: id,
				})
				.then((res) => {
					let form = res.itemArr
					const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
					form.invoiceList = form.invoiceList.map((item) => {
						item.invoice_date = timeFormat(item.invoice_date)
						item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str()
						return item
					})
					this.fileList = form.fileList.filter(item => item.file_type == '1').map((item) => {
						delete item.create_time
						item.flist = []
						return item
					})
					//防空情况
					if (res.itemArr.invoiceList.length === 0) {
						form.invoiceList = [{ invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '', atta_str: atta_str() }]
					}
					if (this.fileList.length === 0) {
						this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
					}
					this.form = form
					setTimeout(() => {
						//权限
						this.level = store.state.level
						this.realName = store.state.realName
					}, 200);
				})
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.addUpdatePay()
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		addUpdatePay() {
			for (let i = 0; i < this.form.invoiceList.length; i++) {
				const element = this.form.invoiceList[i];
				if (!element.invoice_no) {
					this.$message.error('请正确填写所有的发票号码')
					return false
				}
			}
			// 替换掉id为invoice_id
			const $invoiceList = this.form.invoiceList.map((item) => {
				Object.keys(item).forEach(key => {
					if (key == 'id') {
						item['invoice_id'] = item[key] || 0
						console.log(item['invoice_id']);
						delete item[key]
					}
				})
				// 替换掉id为file_id
				item.atta_str = item.atta_str.map((it) => {
					delete it.flist
					delete it.httpFile
					Object.keys(it).forEach(_key => {
						if (_key == 'id') {
							it['file_id'] = it[_key] || 0
							delete it[_key]
						}
					})
					return it
				})
				return item
			})
			this.form.invoiceList = $invoiceList
			//替换掉id为file_id
			let fileList = this.fileList.map((item) => {
				delete item.flist
				delete item.httpFile
				item.file_type = 1
				return item
			})
			let fileList1 = this.fileList1.map((item) => {
				delete item.flist
				delete item.httpFile
				item.file_type = 2
				return item
			})
			fileList = fileList.concat(fileList1)
			let del_atta_list = this.del_atta_list
			let del_atta_list1 = this.del_atta_list1
			const del_atta = del_atta_list.concat(del_atta_list1)
			const $fileList = fileList.map((item) => {
				Object.keys(item).forEach(key => {
					if (key == 'id') {
						item['file_id'] = item[key]
						console.log(item['file_id']);
						delete item[key]
					}
				})
				return item
			})
			fileList = $fileList

			const tempForm = JSON.parse(JSON.stringify(this.form))
			const { id, son_project_id, contract_id, vendor_id } = tempForm
			this.$fly
				.post('apiProject_addUpdatePay.html', {
					pay_id: id,
					son_project_id,
					contract_id,
					vendor_id,
					atta_str: JSON.stringify(fileList),
					atta_del: del_atta.toString(),
					invoice_str: JSON.stringify(this.form.invoiceList),
					invoice_del: this.del_invoice_list.toString(),
					invoice_atta_del: this.del_invoice_atta_list.toString(),
					option: this.form.id ? '2' : '1',
					mType: this.mType,
				})
				.then((res) => {
					console.log(res)
					if (res.status === 200) {
						this.$message.success(res.message)
					}
					this.$router.go(-1)
				})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.$router.go(-1)
		},
	},
}
</script>

<style lang="scss" scoped>
.materialwrap {
	.form.myform {
		padding-left: 100px;
	}

	.form {
		@extend %box;
		padding: 30px;
		margin-bottom: 20px;

		.anlist {
			padding: 0;
			flex-flow: column nowrap;

			li {
				position: relative;
				padding: 0;

				.abtn {
					position: absolute;
					top: 0;
					left: 65%;
				}

				.bbtn {
					position: absolute;
					top: 0;
					left: 60%;
				}
			}
		}
	}

	.formtitle {
		position: relative;
		left: -50px;
		margin-bottom: 30px;
		font-size: 28px;
		line-height: 48px;
		font-weight: 600;
	}

	.base1 {
		@extend %box;
		margin-bottom: 20px;
		padding: 30px 40px;
		position: relative;

		.ntitle {
			display: inline-block;
			margin: 0 0 25px 0;

			&::before {
				width: 100%;
			}
		}

		ul {
			@extend %start;
			color: #231f20;
			background: #f2f2f2;
			padding: 0 25px;
			border-radius: 20px;
			margin-bottom: 20px;
			position: relative;

			&:last-of-type {
				margin-bottom: 0;
			}

			li {
				width: 50%;
				font: 14px/3 $font;

				p {
					min-height: 42px;
					padding: 5px 0;
					@extend %start;

					label {
						width: 150px;
						white-space: nowrap;
						flex: none;
					}

					.bbox {
						width: 100%;
						padding: 0;
						display: block;

						li {
							width: 100%;
							height: 42px;

							&:last-child {
								width: 100%;
								padding-left: 0;
							}
						}
					}

					.anlist {
						padding: 0;
						width: 100%;
						flex-flow: column nowrap;

						li {
							position: relative;
							width: 100%;

							.bbtn {
								position: absolute;
								top: 50%;
								left: 100%;
								transform: translateY(-50%)
							}
						}
					}
				}
			}
		}

	}
}
</style>
